export default __webpack_public_path__ + "static/media/logo.f52a0f53.jpeg";